<!-- opus-four.component.html -->
<div class="model-dialog opus-dialog">
   <button class="close-btn" (click)="close()" aria-label="Close Claude Opus 4.5 dialog">×</button>

  <header class="dialog-header">
    <img
      class="dialog-logo"
      src="assets/logos/anthropic.svg"
      alt="Claude Opus 4.5 Logo"
    />
    <h2 class="dialog-title">Claude Opus 4.5</h2>
    <div class="dialog-subtitle">Anthropic’s Most Intelligent &amp; Capable Model</div>
  </header>

  <div class="dialog-badges">
    <span class="dialog-badge">Frontier-Level Reasoning</span>
    <span class="dialog-badge">Best-in-Class Coding</span>
    <span class="dialog-badge">200K+ Context Mastery</span>
    <span class="dialog-badge dialog-badge--privacy">Enterprise-Grade Privacy</span>
  </div>

  <section class="dialog-body">
    <p class="dialog-lead">
      <strong>Claude Opus 4.5</strong> is Anthropic’s flagship frontier model—built for the most
      demanding work where <span class="accent">deep reasoning</span>,
      <span class="accent">precision</span>, and
      <span class="accent">long-horizon performance</span> matter most. It represents a major step
      forward over Opus 4 in intelligence, coding strength, and sustained coherence in long tasks.
    </p>

    <ul class="dialog-list">
      <li>
        <strong>Optimal For:</strong>
        High-stakes research, multi-step technical problem solving, enterprise workflows, software
        engineering, long-form writing, and complex analysis where quality and correctness matter more
        than speed.
      </li>

      <li>
        <strong>What Makes Opus 4.5 Different:</strong>
        <ul class="dialog-sublist">
          <li>
            <strong>Frontier reasoning upgrades:</strong>
            Stronger multi-step logic, improved judgment, and better handling of ambiguous or
            high-complexity prompts. Opus 4.5 reduces hallucinations compared to earlier generations.
          </li>

          <li>
            <strong>State-of-the-art real-world coding:</strong>
            Built to excel at engineering workflows: debugging, refactoring, architecture planning,
            tests, and long coding sessions.
          </li>

          <li>
            <strong>Long-context expert (200K+ tokens):</strong>
            Handles massive documents, long histories, and multi-source inputs with sustained accuracy—
            ideal for contracts, policy analysis, specs, books, transcripts, and deep research.
          </li>

          <li>
            <strong>Effort control:</strong>
            Supports an <strong>effort parameter</strong> to trade speed vs depth using the same model—
            quick when needed, or extremely thorough when accuracy matters most.
          </li>

          <li>
            <strong>Agentic &amp; workflow-ready:</strong>
            More reliable at tracking objectives, constraints, and multi-step workflows over longer horizons.
          </li>

          <li>
            <strong>Enterprise-grade safety + privacy:</strong>
            Well-suited for sensitive work—legal, regulated industries, confidential planning, internal docs,
            and proprietary business tasks.
          </li>
        </ul>
      </li>

      <li>
        <strong>When to Choose Opus 4.5:</strong>
        <ul class="dialog-sublist">
          <li>When accuracy, nuance, and reliability are mission critical</li>
          <li>When working with long documents or large multi-file context</li>
          <li>For professional coding, system design, and complex debugging</li>
          <li>For enterprise workflows, regulated industries, or confidential data</li>
          <li>When you need a model that stays coherent over long multi-step work</li>
          <li>For premium creative tasks with strong reasoning + consistency</li>
        </ul>
      </li>
    </ul>

    <div class="dialog-callout">
      <span class="callout-icon">★</span>
      <div class="callout-text">
        <strong>Pro Tip:</strong>
        Choose Opus 4.5 when you need the highest possible quality output—especially for long-form work,
        coding, complex research, enterprise-grade reliability, or any high-impact project.
      </div>
    </div>
  </section>
</div>
